import { render, staticRenderFns } from "./modal-verify-smtp-email.vue?vue&type=template&id=b5c445d4&scoped=true&"
import script from "./modal-verify-smtp-email.vue?vue&type=script&lang=js&"
export * from "./modal-verify-smtp-email.vue?vue&type=script&lang=js&"
import style0 from "./modal-verify-smtp-email.vue?vue&type=style&index=0&id=b5c445d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c445d4",
  null
  
)

export default component.exports